import type { StaffCoordinationStaffResponse } from '@/types/apps/staff-coordination-staff.type';
import type {
    ApiResponse,
    PaginatedResult,
    QueryParams,
} from '@/types/common/api.type';
import type { BaseApiClientInterface } from '@/types/service/base-api-client.interface';
import type { Indexable } from '@/types/service/indexable.interface';

export interface StaffCoordinationStaffServiceInterface {}

type StaffCoordinationStaffListResponse = ApiResponse<
    PaginatedResult<StaffCoordinationStaffResponse>
>;

export class StaffCoordinationStaffService implements Indexable {
    public constructor(private apiClient: BaseApiClientInterface) {}

    protected endpoints = {
        base: () => '/api/staff-coordination/staff',
    };

    public index(
        params?: QueryParams
    ): Promise<StaffCoordinationStaffListResponse> {
        return this.apiClient.fetchApi(this.endpoints.base(), params);
    }
}
